import * as React from 'react';
import { ArticleHeading2, InformationTooltip, UIText1 } from '@cian/ui-kit';

import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';
import { ITitleValueListItem } from '../../types/titleValueList';

interface ITitleValueListProps {
  title?: string;
  items: ITitleValueListItem[];
}

export function TitleValueList({ title, items }: ITitleValueListProps) {
  return (
    <div className={styles['container']}>
      {title && <ArticleHeading2 as="h2">{title}</ArticleHeading2>}
      {items.map(({ title, value, valueTooltipText }) => (
        <div key={title} className={styles['item']}>
          <UIText1 color="gray60_100">{title}</UIText1>
          <div className={styles['value-wrapper']}>
            <UIText1>{value}</UIText1>
            {valueTooltipText && (
              <InformationTooltip header={value} content={valueTooltipText} theme="white">
                <div className={styles['faq']} data-testid="NewbuildingSpecificationFaqIcon">
                  <IconFunctionalInformationCircle16 color="icon-main-default" />
                </div>
              </InformationTooltip>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
